import { connect } from 'react-redux';

import { isUserLoggedIn } from 'apps/user/helpers';
import { displayWarning } from 'apps/header/actions/cancelOrderChangesWarning';

import BasketSummaryEdit from '../components/BasketSummaryEdit';

export default connect(
  (state) => ({
    basketMode: state.basket.mode,
    isLoggedIn: isUserLoggedIn(state.user),
  }),
  {
    displayWarning,
  }
)(BasketSummaryEdit);
